module.exports = __webpack_public_path__ + "img/sld_mfm_invs_2_dark.85a1cb4d.svg";